var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"page-footer font-small application-footer"},[_c('div',{staticClass:"footer-copyright text-center py-3"},[_vm._v(" Maat © "+_vm._s(new Date().getFullYear())+" | Todos os direitos reservados ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }